import ElipsisImage from 'images/ellipsis-50px'
import { useEffect, useRef, useState } from 'react'

const SmartButtonStub = (props) => {
  const [state, setState] = useState({})
  const mounted = useRef(true)

  useEffect(() => {
    mounted.current = true

    // this methos will run when component is unmounted
    return () => {
      mounted.current = false
    }
  }, [])

  const onClick = async () => {
    setState({ ...state, spinning: true })
    if (props.click)
      if (props.passPropsToClick)
        await props.click(props)
      else
        await props.click()
    if (mounted.current !== false)
      setState({ ...state, spinning: false })
  }

  let { className, disabled, click, children, text, inverted, buttonType, style, passPropsToClick } = props
  let spinning = props.spinning || state.spinning
  let classes = classNames('smart-button btn', className, { processing: spinning, inverted: inverted && !spinning })

  return (
    <button disabled={disabled} className={classes} onClick={() => onClick()} type={buttonType} style={style}>
      <span className="smart-button-text">{children || text}</span>
      {spinning && <img src={ElipsisImage} className="smart-button-spinner" />}
    </button>
  )
}

export default SmartButtonStub
